"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactoryBillingAutomationMobile = void 0;
const SvcBillingAutomationMobileClient_1 = require("../Client/SvcBillingAutomationMobileClient");
class FactoryBillingAutomationMobile {
    static create(url, configClient) {
        FactoryBillingAutomationMobile.client || (FactoryBillingAutomationMobile.client = new SvcBillingAutomationMobileClient_1.SvcBillingAutomationMobileClient(url, configClient));
        return {};
    }
}
exports.FactoryBillingAutomationMobile = FactoryBillingAutomationMobile;
//# sourceMappingURL=FactoryBillingAutomationMobile.js.map